import { SharedKPIWidget } from '../shared/kpi/SharedKPIWidget';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';
import { useAdminLeadsTodayAdapter } from './adapters/adminKpiAdapters';

export const adminLeadsTodayConfig: WidgetConfig = {
  id: 'admin-leads-today',
  title: 'Today',
  icon: 'today',
  category: 'statistics',
  description: 'Number of leads added today',
  refreshStrategy: 'interval',
  defaultSize: { w: 2, h: 1 },
  priority: 2,
  supportedRoles: ['admin', 'superadmin'],
};

export function AdminLeadsTodayWidget() {
  const dataQuery = useAdminLeadsTodayAdapter();

  return (
    <SharedKPIWidget
      config={adminLeadsTodayConfig}
      dataQuery={dataQuery}
      color="success"
    />
  );
}
